// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","869":"styles"}[chunkId] + "-" + {"245":"8745ac9d37533ae35195","453":"7729b050e995e575fe55","869":"5374910cecc065562712"}[chunkId] + ".js";
};